import { createPlacementComponent as createPlacementComponentActual } from '@post-office/placement-contexts/create-placement-component';
import {
	type ErrorBoundariedProps,
	type PlacementComponent,
	type PlacementConfigurationOptions,
} from '@post-office/placement-contexts/create-placement-component/types';
import { type ReactNode } from 'react';

export const createPlacementComponent = <P,>(
	placementId: string,
	Component: PlacementComponent<P>,
	placementConfigurationOptions?: PlacementConfigurationOptions,
): ((props: ErrorBoundariedProps<P>) => ReactNode) =>
	createPlacementComponentActual(placementId, Component, placementConfigurationOptions);
